// extracted by mini-css-extract-plugin
export default {"tableexample":"b240a7b3f8e005279801","table":"c1766ee0a26ad37241a5"};